import React, { useEffect, useRef } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import mermaid from 'mermaid';

/**
 * Simple test component to verify Mermaid library is working properly
 */
const MermaidTest = () => {
  const mermaidRef = useRef(null);

  // Sample Mermaid diagram for testing
  const sampleDiagram = `
flowchart TD
    A[Start] --> B{Is user logged in?}
    B -->|Yes| C[Dashboard]
    B -->|No| D[Login Page]
    C --> E[View Process Flows]
    D --> F[User Login]
    F --> B
    E --> G[End]
  `;

  useEffect(() => {
    // Initialize Mermaid
    mermaid.initialize({
      startOnLoad: true,
      theme: 'default',
      securityLevel: 'loose',
      flowchart: {
        useMaxWidth: true, 
        htmlLabels: true,
        curve: 'basis'
      }
    });

    renderDiagram();
  }, []);

  const renderDiagram = async () => {
    if (mermaidRef.current) {
      try {
        console.log('Rendering test Mermaid diagram');
        mermaidRef.current.innerHTML = sampleDiagram;
        
        const { svg } = await mermaid.render('mermaid-test-diagram', sampleDiagram);
        mermaidRef.current.innerHTML = svg;
        
        console.log('Mermaid diagram rendered successfully');
      } catch (error) {
        console.error('Error rendering Mermaid diagram:', error);
        mermaidRef.current.innerHTML = `<div style="color: red;">Mermaid Error: ${error.message}</div>`;
      }
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, m: 3 }}>
      <Typography variant="h5" gutterBottom>
        Mermaid Diagram Test
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1">
          This is a test component to verify the Mermaid library is working correctly.
        </Typography>
      </Box>
      
      <Paper variant="outlined" sx={{ p: 2, mb: 3, maxWidth: '100%', overflow: 'auto' }}>
        <div className="mermaid-container" ref={mermaidRef}>
          Loading Mermaid diagram...
        </div>
      </Paper>
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={renderDiagram}
      >
        Re-render Diagram
      </Button>
    </Paper>
  );
};

export default MermaidTest;